import axios from 'axios'
import router from '@/router'
import {
    Toast
} from 'vant';
import md5 from 'js-md5'
import { sha256 } from 'js-sha256';
import {
    Base64
} from 'js-base64';
import {
     Dialog
} from 'vant';
import {
    generateUniappNonce
} from '@/utils/index'
//是否报错弹窗
let isAlert  = true
axios.defaults.withCredentials = false;
// 添加一个请求拦截器
axios.interceptors.request.use((config) => {
    if (config.url.indexOf('/customer/consumerInfo/queryById')>-1){
        //如果是扫一扫进详情页报错则不弹出错误信息
        isAlert = false
    }


    if (config.url.indexOf('/backend/validate/img/public') == -1 
        && config.url.indexOf('/api/tools/qywx/auth/session/public') == -1
        && config.url.indexOf('/api/tools/qywx/auth/login/public') == -1
        && config.url.indexOf('/api/tools/qywx/auth/getUserInfoByCode/public') == -1
        ) {
        const rd = Math.random().toString().slice(-6);
        const timestamp = new Date().getTime();
        const token = sessionStorage.getItem('TOKEN');
        config.headers.uid1 = token;
        config.headers.uid2 = rd;
        config.headers.uid3 = timestamp;
        let salt = "6VNGpr6V9OYuNkI*2p%7Da3_W5^^1O9zZBrP4%tJjE$%#kWa4byZB%z0e#=Mzjob"
        config.headers.uid4 = sha256(token + rd + timestamp + salt);
        config.headers.uid101 = window.location.hostname
        let nonce2 = localStorage.getItem("TOKEN_ACCESS") || "***"
        config.headers.nonce2 = nonce2;
    }
    if (config.url.indexOf('/author/oauth/token') > -1) {
        // let obj = JSON.parse(config.data)
        const uniappNonce = generateUniappNonce();
        const pwd = config.data.get("tryAutoLogin") ? localStorage.getItem('password') :md5(config.data.get("password"));
        let formData = new FormData();
        formData.append('grant_type', 'captcha');
        formData.append('password', pwd);
        formData.append('username', config.data.get("username"));
        formData.append('uniappNonce', uniappNonce);
        localStorage.setItem('password', pwd);
        localStorage.setItem('username', config.data.get("username"));
        config.headers['key'] = config.data.get("key")
        config.headers['code'] = config.data.get("code")
        config.headers['Authorization'] = 'Basic ' + Base64.encode(config.data.get("username") + ':' + pwd)
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
        config.data = formData
    }
    config.headers.dtype2 = "qywx:mobile";
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, (error) => Promise.reject(error));
// 添加一个响应拦截器
axios.interceptors.response.use((res) => {
    const timestamp = new Date().getTime();
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    //后台报错检查An error occurred while attempting to decode the Jwt: Jwt expired at出现时改为中文提示 “JWT已过期，请重新登陆”
    // if (res.data.msg?.indexOf('An error occurred while attempting to decode the Jwt: Jwt expired at') > -1 || res.data.msg?.indexOf('企业微信授权code,手机号登录失败') > -1 || res.data.msg?.indexOf('未查询到相关的内容') > -1) {
        if (res.data.msg?.indexOf('An error occurred while attempting to decode the Jwt: Jwt expired at') > -1) res.data.msg = "JWT已过期，请重新登陆-1"
        // Toast.fail(code + ':' + res.data.msg)
        if(code!=200 && isDifferenceLessThanHour(timestamp, localStorage.getItem('LOGINTINESTAMP'))){
            Dialog.confirm({
                title: '提示',
                message: '请尝试关闭应用重新打开',
            }).catch(() => {
                // on cancel
            });
        }
    if (router.app._route.name != 'loginName' && code != 200 && !isDifferenceLessThanHour(timestamp, localStorage.getItem('LOGINTINESTAMP'))) setTimeout(() => {
            localStorage.setItem('LOGINTINESTAMP', timestamp)
            // Dialog.confirm({
            //     title: '提示',
            //     message: JSON.stringify(router.app._route.query),
            // }).catch(() => {
            //     // on cancel
            // });
            // router.replace({
            //     name: 'loginName',
            //     query: {
            //         ...router.app._route.query,
            //         historyRouterName: router.app._route.name
            //     },
            //     params: {
            //         ...router.app._route.params,
            //     }
            // })
        }, 1000)
        // return res
    // }
    // 获取错误信息
    if (code === 401) {
        Toast.fail(code+':'+res.data.msg)
        return res
    } else if (code === 500) {
        if (!isAlert) return res
        Toast.fail(code+':'+res.data.msg)
        return res
    } else if (code !== 200) {
        Toast.fail(code+':'+res.data.msg)
        return res
    } else {
        return res
    }
}, (error) => {
    const res = error.response
    //后台报错检查An error occurred while attempting to decode the Jwt: Jwt expired at出现时改为中文提示 “JWT已过期，请重新登陆”
    // if (res.data.msg?.indexOf('An error occurred while attempting to decode the Jwt: Jwt expired at') > -1 || res.data.msg?.indexOf('企业微信授权code,手机号登录失败') > -1 || res.data.msg?.indexOf('未查询到相关的内容') > -1) {
        if (res.data.msg?.indexOf('An error occurred while attempting to decode the Jwt: Jwt expired at') > -1)res.data.msg = "JWT已过期，请重新登陆-1"
        Toast.fail(res.status + ':' + (res.data.msg || '系统错误!'))
        if (router.app._route.name != 'loginName')setTimeout(() => {
            // Dialog.confirm({
            //     title: '提示2',
            //     message: JSON.stringify(router.app._route.query),
            // }).catch(() => {
            //     // on cancel
            // });
            // router.replace({
            //     name: 'loginName',
            //     query: {
            //         ...router.app._route.query,
            //         historyRouterName: router.app._route.name
            //     },
            //     params: {
            //         ...router.app._route.params,
            //     }
            // })
        }, 1000)
        
        // return Promise.reject(error);
    // }
    // Toast.fail(res.status + ':' + (res.data.msg || '系统错误!'))
    return Promise.reject(error);
});

const isDifferenceLessThanHour = (timestamp1, timestamp2)=> {
    if (!timestamp2) return false
    const differenceInMilliseconds = Math.abs(timestamp1 - timestamp2);
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
    return differenceInHours < 1;
}
// 通用方法
export const POST = (url, params) => axios.post(url, params).then(
    (res) => res.data
).catch(
    (err) => Promise.reject(err)
)

export const GET = (url, params) => axios.get(url, {
    params
}).then((res) => res.data)
    .catch( 
        (err) => Promise.reject(err)
    )

export const PUT = (url, params) => axios.put(url, params).then((res) => res.data).catch(
    (err) => err
);

export const DELETE = (url, params) => axios.delete(url, {
    params
}).then((res) => res.data);

export const QPUT = (url, params) => axios.put(url, {
    params
}).then((res) => res.data);

// 下载文件的GET请求函数（添加responseType: 'blob'选项）
export const downloadFileGET = (url, params) => axios.get(url, {
    params,
    responseType: 'blob', // 添加响应类型为blob的选项
  }).then((res) => res.data)
    .catch((err) => Promise.reject(err));